{
    "title": "KYC Profile",
    "subtitle": "Please fill in the following fields to complete your KYC profile",
    "input":{
        "primarybusiness": "Primary Business",
        "businessnature": "Nature of Business",
        "ischaritable": "Is an charitable institution?",
        "businessjurisdictions": "Countries in which your company operates",
        "sendjurisdictions": "To which countries will you send funds?",
        "receivejurisdictions": "From which countries will receive funds?",
        "newyorkoffice": "Is the office located in New York?",
        "engageinactivities": "Does your business engage in any of the following activities?",
        "regulatedstatus": "Is your company regulated?",
        "regulationagency": "Regulation Agency Name",
        "regulationagencynumber": "Regulation Agency Number",
        "controlexemptionreason": "Control Exemption Reason",
        "vendorsandcounterparties": "Vendors and Counterparties",
        "isdao": "Is your company a DAO?",
        "transmitscustomerfunds": "Does your company transmit customer funds?",
        "mostrecentoccupation": "Most Recent Occupation",
        "primarypurpose": "Primary Purpose"
    }
}